import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MFilesService } from '../services/mfiles.service';

@Component({
	selector: 'app-history',
	templateUrl: './history.component.html',
	styleUrls: ['./history.component.css']
})
export class HistoryComponent implements OnInit {

	loading = true;
	historyId: number;

	history = [];
	userSortCol = 'date';
	userSortAsc = true;

	constructor(
		private route: ActivatedRoute,
		private mfilesService: MFilesService
	) { }

	ngOnInit(): void {
		this.route.queryParams.subscribe(params => {
			if (params.id) {
				this.historyId = params.id;
				this.loadHistory();
			}
		});
	}

	loadHistory() {
		this.loading = true;
		this.mfilesService.getActionLog(this.historyId).subscribe((result: any[]) => {
			this.history = result;
			for (const log of this.history) {
				log.date = new Date(log.timestamp);
			}
			this.loading = false;
		})
	}

	getSortedFilteredHistory() {
		const shareList = [];

		for (const log of this.history) {
			shareList.push(log);
		}

		if (this.userSortAsc) {
			shareList.sort((a, b) => (a[this.userSortCol] > b[this.userSortCol]) ? 1 : -1);
		} else {
			shareList.sort((a, b) => (a[this.userSortCol] < b[this.userSortCol]) ? 1 : -1);
		}

		return shareList;
	}

	updateSort(col: string) {
		if (this.userSortCol === col) {
			this.userSortAsc = !this.userSortAsc;
		} else {
			this.userSortCol = col;
			this.userSortAsc = true;
		}
	}

}
